import { FailureSeverity } from '../types/FailureSeverity';
import { ValidationFailure } from '../types/ValidationFailure';
import { ValidationResult } from '../types/ValidationResult';

export const validationResult = (failures: ValidationFailure[] = []): ValidationResult => {
  return {
    isValid: !failures.some((p: ValidationFailure) => p.severity === FailureSeverity.Error),
    failures: failures,
  };
};
